<div class="container-fluid" style="padding:0;">
    <div class="part1">
        <div class="searchAndQuote">
            <ul class="searchAndQuoteMenu">
                
                <li class="active vertMiddle" id="menuLeft"><a id="trackShipmentButton" (click)='clicked("track")' style="color:white;">TRACK SHIPMENT</a></li>
                <li class="vertMiddle" id="menuRight"><a id="getAQuoteButton" (click)='clicked("quote")'>GET A QUOTE</a></li>
                <span id="switch"></span>
            </ul>
            <div class="searchAndQuoteImage">
                <div id="locationImageContainer" >
                    <img src="../../assets/image/HL prepare/location pin.png" id="locationPinImage">
                    <img src="../../assets/image/HL prepare/location pin ground.png" id="locationPinGroundImage">
                </div>
    
                <div class="searchAndQuoteImageContainer" id="imageContainer">
                    <img src="../../assets/image/LineClear Box.png" id="parcelImage">
                    <img src="../../assets/image/LineClear Envelope (Document).png" id="documentImage">
                </div>
            </div>
        </div>
        <div class="tab-content">
            <form id="trackShipment" (submit)="getTrackerData('')" >
                <div id="column1">
                    <input type="text" id="trackingNumber" placeholder="Tracking Number" [(ngModel)]="trackCode" [(value)]="trackCode" name="trackCode" >
                    <input type="submit"   id="trackNow" value="TRACK NOW">
                </div>
            </form>
            <form id="getAQuote" style="display:none;" #quoteForm="ngForm" ngNativeValidate (submit)="quoteSubmit(quoteForm)">
                <div id="column2">
                    <div class="postcode">
                        <input id="inputSender" placeholder="From" [(ngModel)]="inputSender" [(value)]="inputSender" name="inputSender" minlength="5" maxlength="5" type="text" > <!-- required -->
                        <input id="inputRecipient" placeholder="To" [(ngModel)]="inputRecipient" [(value)]="inputRecipient" name="inputRecipient" minlength="5" maxlength="5" type="text" > <!-- required -->
                    </div>
                    <div class="verticalBar"></div>
                    <div class="QuoteInfo">
                        <div class="QuoteInfo1">
                            <input id="inputWeight" placeholder="Weight (kg) " [(ngModel)]="inputWeight" [(value)]="inputWeight" name="inputWeight" type="number" step="0.01" min="0"  > <!-- required -->
                            <span class="orText">OR</span>
                        </div>
                        <div class="QuoteInfo2">
                            <input type="text" id="inputLength" placeholder="Length (cm)" [(ngModel)]="inputLength" [(value)]="inputLength" name="inputLength" type="number" step="0.01" min="0"  >
                            <input type="text" id="inputWidth" placeholder="Width (cm)" [(ngModel)]="inputWidth" [(value)]="inputWidth" name="inputWidth" type="number" step="0.01" min="0"  >
                            <input type="text" id="inputHeight" placeholder="Height (cm)" [(ngModel)]="inputHeight" [(value)]="inputHeight" name="inputHeight" type="number" step="0.01" min="0"  >
                        </div>
                    </div>
                    <div class="submission">
                        <div class="submitType">
                            <label class="submitContainer" style="position:relative;">
                                
                                <input type="radio" id="parcel" value="P" name="type" checked="checked" (click)='changeImage("parcel")' [(ngModel)]="inputType">
                                <span class="checkmark"></span>
                                <label for="parcel">Parcel</label><br>
                            </label>
                            <label class="submitContainer" id="marginControl" style="position:relative;">
                                
                                <input type="radio" id="document" value="D" name="type" (click)='changeImage("document")' [(ngModel)]="inputType">
                                <span class="checkmark"></span>
                                <label for="document">Document</label><br>
                            </label>
                        </div>

                        <input type="submit"  id="quoteNow" value="QUOTE NOW">
                    </div>
                    
                </div>
            </form>
            
        </div>
        <div class="result-content" id="result-content">
            <div class="trackerResult" *ngIf="trackerDisplay" id="trackerResult">
                <div *ngFor="let list of trackerListRecon" class="container-fluid">
                  <div class="row">
                    <div class="col-12" id="trackerImage">
                      <img [src]="list.image" class="center-block img-responsive step-img" >
                    </div>
            
                    <div class="col-12 text-center" id="trackerID">
                        <p class="label">TRACKER ID : {{list.data['0'].WayBillNumber}}</p>    
                    </div>
                  </div>
                  <div *ngFor="let item of list.data; first as isFirst" class="row progress-text-row" >
                    <div class="col-md-12" style="padding:0;">
                      <div *ngIf="isFirst; else pendingJob" class="col-xs-3 col-md-2 job-done progress-text-column" >
                        <div class="col-md-12 time-col vcenter ">
                          <p class=" progress-text">{{item.LastModifiedDate}}
                            <br>{{item.LastModifiedTime}}</p>
                        </div>
                      </div>
            
                      <ng-template #pendingJob>
                        <div class="col-xs-3 col-md-2 job-pending progress-text-column" >
                            <div class="col-md-12 time-col vcenter">
                              <p class=" progress-text">{{item.LastModifiedDate}}
                                <br>{{item.LastModifiedTime}}</p>
                            </div>
                        </div>
                      </ng-template>
            
                      <div class="col-xs-9 col-md-10 progress-text-column item-description" >
                        <div class="col-md-12 detail-col vcenter">
                          <p class=" progress-text">{{item.Description}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
            
                </div>
            </div>
            


            <div class="quoteResult" *ngIf="quoteDisplay" id="quoteResult">
                <div class="quoteRoute">
                    <p class="senderCity">{{displaySender}}<br>{{origincity | uppercase}}</p>
                    <div class="triangle-container"><span id="triangle-right"></span></div>
                    <p class="recipientCity">{{displayRecipient}}<br>{{destinationcity | uppercase}}</p>
                </div>
                <div class="quoteDetails">
                    <div class="quoteDetails1">
                        <p>Item Type : {{itemType}}</p>
                        <p>Weight : {{displayWeight}} KG</p>
                    </div>
                    <div class="quoteDetails2" id="quoteDetails2-marginTop">
                        <p>Delivery Fee</p><p>{{deliverycharge | number: '1.2-2'}}</p>
                    </div>
                    <div class="quoteDetails2">
                        <p>Surchanges</p><p>{{surcharge | number: '1.2-2'}}</p>
                    </div>
                    <div class="quoteDetails2" id="quoteDetails2-marginBottom">
                        <p>Estimated Price</p><p>{{price | number: '1.2-2'}}</p>
                    </div>
                    <div class="quoteDetails3">
                        <ul>
                            <li>Surcharge are estimated for Out of Delivery Area.</li>
                            <li>Weight are applied based on Volumetric Weight (L x W x H /6000) or actual
                            weight whichever is higher.</li>
                            <li>Line Clear Express reserves the right to change the rate without prior
                            notice.</li>
                        </ul>
                    </div>
                    <a (click)="goToPortal()"><button type="submit" class="bookNow">Book Now</button></a>
                </div>
            </div>
            
        </div>
    </div>

    <div class="part2">
        <div class="part2-laptop hidden-xs">
            <div class="part2Title">
                <h3>OUR PRODUCTS</h3>
                <h4>Explore our range of services to suit your needs.</h4>
            </div>
            <div class="part2Container">
                <ul class="serviceList" >
                    <li (click)='service("express")'><img src="../../assets/image/OUR PRODUCTS/EXPRESS TOGGLE.png" id="express-service" ></li>
                    <li (click)='service("valuePack")'><img src="../../assets/image/OUR PRODUCTS/VALUEPACK DEFAULT.png" id="valuePack-service" ></li>
                    <li (click)='service("premium")'><img src="../../assets/image/OUR PRODUCTS/PREMIUM DEFAULT.png" id="premium-service" ></li>
                    <li (click)='service("premiumBox")'><img src="../../assets/image/OUR PRODUCTS/PREMIUMBOX DEFAULT.png" id="premiumBox-service" ></li>
                    <li (click)='service("freshBox")'><img src="../../assets/image/OUR PRODUCTS/FRESHBOX DEFAULT.png" id="freshBox-service" ></li>
                </ul>
                <div class="serviceImageList" id="serviceImageList">
                    <img src="../../assets/image/Service-Express.png" id="Service-Express" style="display:block;">
                    <img src="../../assets/image/Service-Valuepack.png" id="Service-Valuepack" >
                    <img src="../../assets/image/Service-Premium _ PremiumBox.png" id="Service-Premium" style="transform: scale(0.8);">
                    <img src="../../assets/image/Service-Premium _ PremiumBox.png" id="Service-PremiumBox" >
                    <img src="../../assets/image/Service-FreshBox.png" id="Service-FreshBox" >
                </div>
                <div class="serviceDescriptionList" id="serviceDescriptionList">
                    <div class="serviceDescription" id="serviceDescription1" style="display:block;">
                        <p>Cost-effective express delivery.</p>
                        <p>Applicable nationwide.</p>
                        <p>1-3days delivery.</p>
                        <p>As low as RM7 for the first 3kg.</p>
                    </div>
                    <div class="serviceDescription" id="serviceDescription2">
                        <p>Item must be packed into</p>
                        <p>ValuePackflyers. Applicable</p>
                        <p>nationwide. 1-3 days delivery.</p>
                        <p>As low as RM14.99 for </p>
                        <p>the first 3kg.</p>
                    </div>
                    <div class="serviceDescription" id="serviceDescription3">
                        <p>WorryFree delivery.</p>
                        <p>Applicable nationwide.</p>
                        <p>Next day delivery. GUARANTEED.</p>
                        <p>As low as RM15.</p>
                    </div>
                    <div class="serviceDescription" id="serviceDescription4">
                        <p>Item must be packed into specific</p>
                        <p>box dimension. WorryFree.</p>
                        <p>Next day delivery. GUARANTEED.</p>
                        <p>As low as RM15.</p>
                    </div>
                    <div class="serviceDescription" id="serviceDescription5">
                        <p>Frozen and fresh produce delivery.</p>
                        <p>Next day delivery.</p>
                        <p>GUARANTEED.</p>
                        <p>As low as RM15.</p>
                    </div>
                    <div class="serviceOtherDescription">
                        <a href="javascript:;" (click)="goToRateChart()" class="serviceOtherDescriptionButton" id="rateChart">RATE CHART</a>
                        <a href="javascript:;"  class="serviceOtherDescriptionButton" id="faq">FAQ</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="part2-mobile hidden-sm hidden-md hidden-lg">
            <div class="part2Title-mobile">
                <h3>OUR PRODUCTS</h3>
                <h4>Explore our range of services to suit your needs.</h4>
            </div>
            <div class="part2Container-mobile">

            <div class="slider">
                <div class="customSlide">
                  <div class="slide-h3" id="slide1"> <!-- (change)="slideChange()" -->
                    <img src="../../assets/image/OUR PRODUCTS (MOBILE)/EXPRESS BLUR.png" alt="Service-Express" id="slideImage1">
                </div>
                </div>
                <div class="customSlide">
                    <div class="slide-h3" id="slide2">
                        <img src="../../assets/image/OUR PRODUCTS (MOBILE)/VALUEPACK BLUR.png" alt="Service-Valuepack" id="slideImage2">
                    </div>
                </div>
                <div class="customSlide">
                 <div class="slide-h3" id="slide3">
                    <img src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUM BLUR.png" alt="Service-Premium" id="slideImage3">
                </div>
                </div>
                <div class="customSlide">
                  <div class="slide-h3" id="slide4">
                    <img src="../../assets/image/OUR PRODUCTS (MOBILE)/PREMIUMBOX BLUR.png" alt="Service-PremiumBox" id="slideImage4">
                  </div>
                </div>
                <div class="customSlide">
                   <div class="slide-h3" id="slide5">
                    <img src="../../assets/image/OUR PRODUCTS (MOBILE)/FRESHBOX BLUR.png" alt="Service-FreshBox" id="slideImage5">
                   </div>
                </div>
              
              </div>
              <div class="sliderContent" id="sliderContent">
                <div id="sliderContent1">
                    <p>Cost-effective express delivery.</p>
                    <p>Applicable nationwide.</p>
                    <p>1-3days delivery.</p>
                    <p>As low as RM7 for the first 3kg.</p>
                </div>
                <div id="sliderContent2">
                    <p>Item must be packed into</p>
                    <p>ValuePackflyers. Applicable</p>
                    <p>nationwide. 1-3 days delivery.</p>
                    <p>As low as RM14.99 for </p>
                    <p>the first 3kg.</p>
                </div>
                <div id="sliderContent3">
                    <p>WorryFree delivery.</p>
                    <p>Applicable nationwide.</p>
                    <p>Next day delivery. GUARANTEED</p>
                    <p>As low as RM15.</p>
                </div>
                <div id="sliderContent4">
                    <p>Item must be packed into specific</p>
                    <p>box dimension. WorryFree.</p>
                    <p>Next Day delivery. GUARANTEED.</p>
                    <p>As low as RM15.</p>
                </div>
                <div id="sliderContent5">
                    <p>Frozen and fresh produce delivery.</p>
                    <p>Next day delivery.</p>
                    <p>GUARANTEED.</p>
                    <p>As low as RM15.</p>
                </div>
              </div>
              <div class="serviceOtherDescription">
                <button class="serviceOtherDescriptionButton" id="rateChart">RATE CHART</button>
                <button class="serviceOtherDescriptionButton" id="faq">FAQ</button>
            </div>
            </div>
        </div>
    </div>


    <div class="part3">
        <h4>START SHIPPING TODAY</h4>
        <div class="part3Container">
            <div class="part3Image">
                <img class="fullImage" src="../../assets/image/STARTSHIPPING/STATIC.png" id="hoverImage">
            </div>
            <div class="part3Content">
                <div class="part3ExtraImage" id="part3ExtraImage1">
                    <img src="../../assets/image/STARTSHIPPING/NATIONWIDE.png" style="transform:scale(1.4);transform-origin: bottom;">
                </div>
                <div class="part3TextContainer"> 
                    <h5 class="part3TextTitle" (mouseover)='over(1)' (mouseout)='out()'>Nationwide Coverage</h5>
                    <p>With over 146 Hubs, Depots and Stations, our services run 24 hours a day, 
                        covering the primary and secondary towns in Peninsular and East Malaysia.
                    </p>
                </div>
                <div class="part3ExtraImage" id="part3ExtraImage2" (mouseout)='out()'>
                    <img src="../../assets/image/STARTSHIPPING/CREATESHIPMENT.png">
                </div>
                <div class="part3TextContainer">
                    <h5 class="part3TextTitle" (mouseover)='over(2)' (mouseout)='out()'>Create Shipments</h5>
                    <p>Create shipments at your fingertips anytime and anywhere with our mobile 
                        friendly Order Management System.
                    </p>
                </div>
                <div class="part3ExtraImage" id="part3ExtraImage3">
                    <img src="../../assets/image/STARTSHIPPING/PICKUPS.png">
                </div>
                <div class="part3TextContainer">
                    <h5 class="part3TextTitle" (mouseover)='over(3)' (mouseout)='out()'>Parcel Pick Ups</h5>
                    <p>Easily place a booking for parcel pick ups and wait for our Abang Courier 
                        to pick up from your address.
                    </p>
                </div>
                <div class="part3ExtraImage" id="part3ExtraImage4">
                    <img src="../../assets/image/STARTSHIPPING/DELIVERY.png">
                </div>
                <div class="part3TextContainer">
                    <h5 class="part3TextTitle" (mouseover)='over(4)' (mouseout)='out()'>Worry Free Delivery</h5>
                    <p>97% timely delivery rate on Next Day Delivery Guaranteed services making 
                        us one of the most reliable local courier service.
                    </p>
                </div>
                <div class="part3Sign_Up" >
                    <button style="cursor: pointer;"  id="signUpNow" (click)="goToPortal()">SIGN UP NOW</button>
                </div>
            </div>
        </div>
    </div>

    <div class="part4">
        <h4 class="videoTitle">OUR STORIES</h4>
        <iframe class="video" src="https://www.youtube.com/embed/nqm_XXJ_sfc" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
</div>